import { Component, computed, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { MbmModalComponent } from '@modals/mbm-modal/mbm-modal.component';
import { MbmAvatarComponent, MbmButtonComponent } from '@components';
import { DataContext } from '@services/data-context';

/** Design "Logg ut" sheet: avatar, name, company and Avbryt / Logg ut. */
@Component({
  selector: 'mbm-logout-sheet',
  imports: [TranslateModule, MbmModalComponent, MbmAvatarComponent, MbmButtonComponent],
  templateUrl: './logout-sheet.component.html',
  styleUrl: './logout-sheet.component.scss',
})
export class LogoutSheetComponent {
  private readonly modalController = inject(ModalController);
  private readonly dataContext = inject(DataContext);

  protected readonly userName = computed(() => this.dataContext.loggedInUser()?.name ?? '');
  protected readonly userCompany = computed(() => {
    const context = this.dataContext.projectContext();
    const user = this.dataContext.loggedInUser();
    return context?.currentUser?.id === user?.id ? context?.currentUser?.companyName ?? '' : (user?.email ?? '');
  });

  protected onCancel(): void {
    void this.modalController.dismiss(null, 'cancel');
  }

  protected onLogout(): void {
    void this.modalController.dismiss(null, 'logout');
  }
}
